import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getStringFromObject } from '../../../constants/lodashUtils';
import { isValidTextAndNotEmpty } from '../../../constants/CommonUtil';
import { iframeUrlMap } from '../../../constants/constants';
import IframeDialogComponentV2 from '../../IframeDialogComponentV2/IframeDialogComponentV2';
import { getMemoTitle } from '../CreditOrDebitMemoV2/CreditOrDebitMemoUtilsV2';

const CreditOrDebitMemoWrapper = (props) => {
    const {
        memoType,
        invoiceUuid,
        iframeFormsBase,
        ...otherProps
    } = props;

    let iframeUrl = `${iframeFormsBase}${iframeUrlMap.MEMO}?memoType=${memoType}`;
    if (isValidTextAndNotEmpty(invoiceUuid)) {
        iframeUrl = `${iframeUrl}&memoInvoiceUuid=${invoiceUuid}`;
    }

    return (
        <IframeDialogComponentV2
            header={getMemoTitle(memoType)}
            open
            iframeUrl={iframeUrl}
            fullScreen
            {...otherProps}
        />
    );
};

CreditOrDebitMemoWrapper.propTypes = {
    iframeFormsBase: PropTypes.string.isRequired,
    memoType: PropTypes.string.isRequired,
    invoiceUuid: PropTypes.string,
    invoiceId: PropTypes.number,
};

CreditOrDebitMemoWrapper.defaultProps = {
    invoiceUuid: '',
    invoiceId: null,
};

const mapStateToProps = state => ({
    iframeFormsBase: getStringFromObject('appConfiguration.iframeFormsBase', state) || '',
});

export default connect(mapStateToProps)(CreditOrDebitMemoWrapper);
